import { GameState } from '@lc/interface/gameState/types';
import { Player } from '@lc/interface/player/types';

export function getActivePlayer(
	playerStateArray: Player[],
	activePlayerId: number
) {
	for (let i = 0; i < playerStateArray.length; i++) {
		if (playerStateArray[i].playerId === activePlayerId) {
			return playerStateArray[i];
		}
	}

	return null;
}

export function getPlayerStateWithId(
	playerStateArray: Player[],
	playerId: number
) {
	// console.log('getPlayerStateWithId');
	// console.log('playerId');
	// console.log(playerId);
	for (let i = 0; i < playerStateArray.length; i++) {
		if (playerStateArray[i].playerId === playerId) {
			// console.log(i);
			// console.log('myState');
			// console.log(playerStateArray[i]);

			return playerStateArray[i];
		}
	}

	return playerStateArray[0]; // stopgap measure
}

export function getPlayerArrayIndex(
	playerStateArray: Player[],
	playerId: number
) {
	for (let i = 0; i < playerStateArray.length; i++) {
		if (playerStateArray[i].playerId === playerId) {
			return i;
		}
	}

	return -1;
}

export function getPlayerIdFromArrayIndex(
	playerStateArray: Player[],
	playerIndex: number
) {
	if (playerIndex < playerStateArray.length) {
		return playerStateArray[playerIndex].playerId;
	}

	return -1;
}

// TODO replaced gameManager with gameState
export function isPlayerTurn(playerId: number, gameState: GameState) {
	console.log('playerId ' + playerId);
	console.log('gameState.activePlayerId ' + gameState.activePlayerId);
	return playerId === gameState.activePlayerId;
}

export function isActivePlayerIdAI(gameState: GameState): boolean {
	const activePlayerState = getActivePlayer(
		gameState.playerStateArray,
		gameState.activePlayerId
	);

	if (!activePlayerState || !activePlayerState.isBot) {
		return false;
	}

	return true;
}
